import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CONFERENCE } from '../data/conference';

const Wrap = styled.div`
  display: inline-flex;
  align-items: stretch;
`;

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.4rem clamp(0.9rem, 2.6vw, 1.8rem);
  min-width: clamp(64px, 9vw, 92px);

  & + & {
    border-left: 1px solid var(--line);
  }
`;

const Num = styled.span`
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: clamp(1.5rem, 3.4vw, 2.2rem);
  font-weight: 600;
  color: var(--ink);
  line-height: 1.1;
`;

const Label = styled.span`
  font-family: var(--font-mono);
  font-size: 0.62rem;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--copper);
  margin-top: 0.3rem;
`;

function diffToParts(targetMs) {
  const delta = Math.max(0, targetMs - Date.now());
  return {
    days: Math.floor(delta / 86400000),
    hours: Math.floor(delta / 3600000) % 24,
    minutes: Math.floor(delta / 60000) % 60,
    seconds: Math.floor(delta / 1000) % 60,
  };
}

export default function Countdown() {
  const target = new Date(CONFERENCE.startDateISO).getTime();
  const [parts, setParts] = useState(() => diffToParts(target));

  useEffect(() => {
    const id = setInterval(() => setParts(diffToParts(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const pad = (n) => String(n).padStart(2, '0');

  return (
    <Wrap role="timer" aria-label={`Countdown to ${CONFERENCE.shortName}`}>
      <Cell>
        <Num>{parts.days}</Num>
        <Label>Days</Label>
      </Cell>
      <Cell>
        <Num>{pad(parts.hours)}</Num>
        <Label>Hrs</Label>
      </Cell>
      <Cell>
        <Num>{pad(parts.minutes)}</Num>
        <Label>Min</Label>
      </Cell>
      <Cell>
        <Num>{pad(parts.seconds)}</Num>
        <Label>Sec</Label>
      </Cell>
    </Wrap>
  );
}
